import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { ConsultRepository } from '../../repositories/consult.repository';
import { RipsEntity } from '../../../data/repositories/consult/entities/rips-entity';

export class GetRipsReportByDateUseCase
  implements
    UseCase<
      {
        DateInit: Date;
        DateEnd: Date;
        idEnablingsCode: string;
        idNationality: string;
      },
      RipsEntity
    >
{
  constructor(private ConsultRepository: ConsultRepository) {}
  execute(params: {
    DateInit: Date;
    DateEnd: Date;
    idEnablingsCode: string;
    idNationality: string;
  }): Observable<RipsEntity> {
    return this.ConsultRepository.getRipsReportByDate(params);
  }
}
